/* Men's colour selector: photo tiles + gallery sync.

   THE TWO BUGS THIS FIXES
   1. On a product whose colourways are VARIANTS (the men's frames: Diplomat,
      Commander, Aviator), picking a colour updated the cart variant, the
      price, the button and the sticky bar - but left the gallery on the first
      photo. A customer choosing Gold saw Silver and bought Gold. The change
      handler in sections/main-product.liquid simply never touched the gallery.
   2. The men's colour selector was plain text pills while the women's side
      had photo tiles you could actually see the colour in. Same job, two
      interfaces. snippets/colourways.liquid now renders tiles for the variant
      case too; this file makes them work and hides the redundant pills.

   WHY MATCHING IS DONE ON THE FILENAME
   The gallery is built from product.media, so each slide carries a MEDIA id.
   The variant JSON carries featured_image, which has an IMAGE id. Those are
   different id namespaces and never compare equal, so they cannot be matched
   on id. They do resolve to the same uploaded file, so the filename is the
   reliable join key.

   WHY THIS IS A SEPARATE FILE
   main-product.liquid holds its gallery goTo() inside a closure that is not
   reachable from outside. Rather than rewrite that 17KB section to expose it,
   this script sets the same attributes goTo() sets (data-active on slides,
   aria-current on dots and thumbs), so dots and thumbnails stay in step. If
   anyone is editing main-product.liquid anyway, this belongs inside its
   bindVariants() and this file can go.

   PROGRESSIVE ENHANCEMENT
   The real radio inputs are never removed, only hidden, and only once this
   script has run. With JavaScript off the pills stay visible and the page
   still works. Everything listens by delegation on document, so it survives
   the colourway swap replacing [data-product-root] innerHTML.
*/
(function () {
  'use strict';

  function form() {
    var info = document.querySelector('.product-info');
    return info && info.querySelector('form[action*="/cart/add"]');
  }

  function fileKey(u) {
    if (!u) return '';
    var s = String(u).split('?')[0];
    return s.substring(s.lastIndexOf('/') + 1);
  }

  function slides() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-gallery] .gallery-slide')
    );
  }

  function goTo(i) {
    var sl = slides();
    if (!sl[i]) return;
    sl.forEach(function (s, n) {
      s.setAttribute('data-active', n === i ? 'true' : 'false');
    });
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-gallery-dots] button'),
      function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); }
    );
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-gallery-thumbs] button'),
      function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); }
    );
  }

  function markTiles(value) {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-variant-colourways] button.colourway'),
      function (b) {
        var on = b.getAttribute('data-opt-value') === value;
        b.classList.toggle('is-on', on);
        if (on) { b.setAttribute('aria-current', 'true'); }
        else { b.removeAttribute('aria-current'); }
      }
    );
  }

  /* Hide the text pills for the option the tiles now cover. Scoped by label
     text, so a product that ever gains a second option (Size, say) keeps its
     own pills. */
  function hidePills() {
    var wrap = document.querySelector('[data-variant-colourways]');
    if (!wrap) return;
    var name = (wrap.getAttribute('data-colour-option') || '').trim().toLowerCase();
    if (!name) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('.product-info .option-group'),
      function (g) {
        var label = g.querySelector('.option-label');
        if (label && label.textContent.trim().toLowerCase() === name) g.hidden = true;
      }
    );
  }

  function sync() {
    var info = document.querySelector('.product-info');
    var f = form();
    if (!info || !f) return;

    var chosen = Array.prototype.slice
      .call(f.querySelectorAll('[data-option-selector]:checked'))
      .map(function (i) { return i.value; });
    if (!chosen.length) return;

    markTiles(chosen[0]);

    var sl = slides();
    if (sl.length < 2) return;

    var variants = [];
    try { variants = JSON.parse(info.getAttribute('data-variants') || '[]'); } catch (e) { return; }

    var match = variants.filter(function (vr) {
      return chosen.every(function (val, i) { return vr.options[i] === val; });
    })[0];
    if (!match || !match.featured_image) return;

    var want = fileKey(match.featured_image.src);
    if (!want) return;

    var i = sl.map(function (s) {
      var img = s.querySelector('img');
      return fileKey(img && img.getAttribute('src'));
    }).indexOf(want);

    if (i > -1) goTo(i);
  }

  function refresh() {
    hidePills();
    sync();
  }

  /* A tile click drives the real radio. The section's own change handler then
     updates the variant id, price, button and sticky bar exactly as before -
     this script adds no second source of truth. */
  document.addEventListener('click', function (e) {
    var tile = e.target && e.target.closest &&
      e.target.closest('[data-variant-colourways] button.colourway');
    if (!tile) return;

    var f = form();
    if (!f) return;

    var value = tile.getAttribute('data-opt-value');
    var radio = Array.prototype.slice
      .call(f.querySelectorAll('[data-option-selector]'))
      .filter(function (r) { return r.value === value; })[0];
    if (!radio || radio.checked) { markTiles(value); return; }

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    markTiles(value);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-option-selector]')) sync();
  });

  /* Landing on ?variant=... or a shared colour link must open on that
     colour's photo and tile, not on slide 1. */
  refresh();

  /* The women's colourway swap replaces [data-product-root] innerHTML and
     re-runs the section's own init(). Re-apply once the new markup lands. */
  var root = document.querySelector('[data-product-root]');
  if (root && window.MutationObserver) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 50);
    }).observe(root, { childList: true });
  }

  window.addEventListener('pageshow', refresh);
})();
